import {Pipe, PipeTransform} from '@angular/core';
import {WidgetGroupDto} from '../../Models/Widgets/widget.interface';

@Pipe({
  name: 'widgetsGroups',
  standalone: false
})
export class WidgetsGroupsPipe implements PipeTransform {

  transform(items: WidgetGroupDto[], filter: { favorite: boolean }): WidgetGroupDto[] {

    if (!items.length) {
      return [];
    }

    return items.filter((group) =>
      group.widgets.some((item) => filter.favorite ? item.favorite : !item.favorite));

  }

}
